export default __webpack_public_path__ + "static/media/(80).2dce6834.jpg";